import { configureStore } from "@reduxjs/toolkit";
import UserReducer from "./User";
import StyleReducer from "./style";
import ImagesReducer from "./images";
import FeaturesReducer from "./features";
import TemplateReducer from "./template";
import authSlice from "./Auth";
import uploadBanner from "./Features/uploadBanner";
import disclaimer from "./Features/disclaimer";
import downloadApp from "./Features/downloadApps";
import html from "./Features/Html";
import quote from "./Features/quote";
import videoConference from "./Features/videoConference";

export default configureStore({
  reducer: {
    user: UserReducer,
    userTemplate: TemplateReducer,
    userStyle: StyleReducer,
    userImages: ImagesReducer,
    userFeatures: FeaturesReducer,
    uploadBanner: uploadBanner,
    disclaimer: disclaimer,
    downloadApp: downloadApp,
    htmlFeature: html,
    quote: quote,
    videoConference: videoConference,
    Auth: authSlice,
  },
});
